export enum Client {
    ABAPP = 'ab-app',
    ABCONFIRMTKT = 'ab-confirmtkt',
    ABGPAY = 'ab-gpay',
    ABHIBUS = 'abhibus',
    ABIXIFLIGHTS = 'ab-ixiflights',
    ABIXIMWEB = 'ab-iximweb',
    ABIXITRAINS = 'ab-ixitrains',
    ABMWEB = 'ab-mweb',
    ABUSAD = 'abusad',
    ABUSADHC = 'abusad-hc',
    ABUSIO = 'abusio',
    ABUSIOHC = 'abusio-hc',
    ABWEB = 'abhibus-web',
    CONFIRMTCKT = 'confirmtckt',
    CTWEB = 'ct-web',
    CTMWEB = 'ct-mweb',
    IXIMAAD = 'iximaad',
    IXIMAIO = 'iximaio',
    IXIMATR = 'iximatr',
    IXIMWEB = 'iximweb',
    IXIMWEBIC = 'iximwebic',
    IXITRIO = 'ixitrio',
    IXIWEB = 'ixiweb',
    IXIWEBIC = 'ixiwebic',
    NIYO = 'niyo',
}

export enum ThirdPartyClient {
    UBER = 'uber',
}

export enum Language {
    'EN' = 'en',
    'HI' = 'hi',
}

export enum Organisation {
    ABHIBUS = 'abhibus',
    CONFIRMTKT = 'confirmtkt',
    IXIGO = 'ixigo',
}

export enum LocalStorage {
    CACHED_USER_INFO_KEY = 'abhibusUserInfo',
}
